import { render, staticRenderFns } from "./DashboardPatient.vue?vue&type=template&id=84b6d1ac&"
import script from "./DashboardPatient.vue?vue&type=script&lang=js&"
export * from "./DashboardPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports